import React from "react";
import ReactDOM from "react-dom";
import Screen from "../ui/Screen";

const globalScreens = [];

export const dismissGlobalScreen = () => {
    const close = globalScreens[globalScreens.length - 1];

    if (!close) return false;

    close(null);
    return true;
};

export const createScreen = (options = {}) => {
    const {
        closable = false,
        is_modal = false,
        component,
        title = "",
        offset = [0, 0],
        callback = () => { },
        signal = {},
        target = null,
        globalScreen = false,
    } = options;

    const mountPoint = target?.current || target || document.querySelector(".ui-main");
    if (!mountPoint) return;

    const div = document.createElement("div");
    div.className = "ui-screen-overlay";

    mountPoint.appendChild(div);

    let closed = false;

    const closeScreen = (e) => {
        if (closed) return;
        closed = true;

        const index = globalScreens.indexOf(closeScreen);
        if (index !== -1) {
            globalScreens.splice(index, 1);
        }

        try {
            callback(e);
        } finally {
            ReactDOM.unmountComponentAtNode(div);
            div.remove();
        }
    };

    if (globalScreen) {
        globalScreens.push(closeScreen);
    }

    ReactDOM.render(
        <Screen
            is_modal={is_modal}
            offset={offset}
            signal={signal}
            closable={closable}
            title={title}
            callback={closeScreen}
            component={component}
        />,
        div
    );

    return closeScreen;
};